"use strict";
/**
 * Created by Jonas Wålekvist on 2019-10-11.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeypadSound = void 0;
var KeypadSound;
(function (KeypadSound) {
    KeypadSound["NONE"] = "";
    KeypadSound["CLICK"] = "click";
    KeypadSound["DISABLED"] = "disabled";
    KeypadSound["FAST_SPIN_OFF"] = "fast-spin-off";
    KeypadSound["FAST_SPIN_ON"] = "fast-spin-on";
    KeypadSound["SPIN_START"] = "spin-start";
    KeypadSound["SPIN_STOP"] = "spin-stop";
})(KeypadSound = exports.KeypadSound || (exports.KeypadSound = {}));
//# sourceMappingURL=KeypadSound.js.map